import { PropsWithChildren, createContext, useContext } from 'react'

import { AvailableOrInstalledConnection } from 'app/connections/types'

const ConnectionContext = createContext<AvailableOrInstalledConnection | null>(null)

interface ConnectionProviderProps extends PropsWithChildren {
  connection: AvailableOrInstalledConnection
}

export const ConnectionProvider = ({ children, connection }: ConnectionProviderProps) => (
  <ConnectionContext.Provider value={connection}>{children}</ConnectionContext.Provider>
)

// eslint-disable-next-line react-refresh/only-export-components
export const useConnection = () => {
  const connection = useContext(ConnectionContext)

  if (!connection) {
    throw new Error('useConnection must be used inside ConnectionProvider')
  }

  return connection
}
